import { createSlice } from '@reduxjs/toolkit';

export interface SideBar {
    userData: any[];
    loggedInUserData: any[];
    accessToken: any[];
    loggdInUserName: any[];
    loggedInUserId: any[];
    companyDetails: {};
    companyList: any[];
    isLLAdminUser: boolean;
}

const initialState: SideBar = {
    userData: [],
    loggedInUserData: [],
    accessToken: [],
    loggdInUserName: [],
    loggedInUserId: [],
    companyDetails: {},
    companyList: [],
    isLLAdminUser: false,
};

export const SideBarSlice = createSlice({
    name: 'SideBar',
    initialState,
    reducers: {
        setUserData: (state, { payload }) => {
            state.userData = payload;
        },
        setLoggedInUserInfo: (state, { payload }) => {
            state.loggedInUserData = payload;
        },
        setAccessToken: (state, { payload }) => {
            state.accessToken = payload;
        },
        setLoggedinUsername: (state, { payload }) => {
            state.loggdInUserName = payload;
        },
        setLoggedInUserId: (state, { payload }) => {
            state.loggedInUserId = payload;
        },

        setCompanyList: (state, { payload }) => {
            state.companyList = payload;
        },

        setCompanyDetails: (state, { payload }) => {
            state.companyDetails = payload;
        },

        setIsLLAdminUser: (state, { payload }) => {
            state.isLLAdminUser = payload;
        },
        
    },
});

// Action creators are generated for each case reducer function
export const {
    setUserData,
    setLoggedInUserInfo,
    setAccessToken,
    setLoggedinUsername,
    setLoggedInUserId,
    setCompanyList,
    setCompanyDetails,
    setIsLLAdminUser
} = SideBarSlice.actions;

export default SideBarSlice.reducer;
